import React from "react";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import { makeStyles, Grid } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2, 2, 2, 2),
  },
}));
const SurveyCompleted: React.FC = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <Grid container justify="flex-start">
        <Grid item xs={12} md={6}>
          <Paper className={classes.root}>
            <Typography variant="h5">Thank you for your feedback</Typography>
            <br />
            <Typography variant="body1">
              Soon the summarised results will be sent to your manager to
              discuss with your team. If you have any questions about the Vital
              Teams survey, please contact us at{" "}
              <a href="mailto:support@vitalteams.com">support@vitalteams.com</a>
              .
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default SurveyCompleted;
